/**
 * DownloadButton — writes `text` to a file download. Icon-only; pair it with a
 * CopyButton (which carries the visible label) in a ButtonGroup.
 */
import { Download } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/_shared/components/ui/button';

export interface DownloadButtonProps {
  text: string;
  filename: string;
}

export function DownloadButton({ text, filename }: DownloadButtonProps): React.JSX.Element {
  const onDownload = React.useCallback(() => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }, [text, filename]);

  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      aria-label="Download"
      Icon={<Download />}
      onClick={onDownload}
    />
  );
}
